export const margin = {
    // todo -- get with mike L for other padding values as they become needed. Ideally we should create a formula.
    sm: '15px',
    md: '20px',
};
//# sourceMappingURL=margin.js.map